export default __webpack_public_path__ + "static/media/footer_bg.ff173d50.png";